export default __webpack_public_path__ + "static/media/ic_trash.6b5c7137.svg";